import { FetchQuestionsData, QA, QaService } from "@/client";
import { HttpError } from "@/types/error";
import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";

const qaQueryKey = (filter: FetchQuestionsData) => ["qa", filter];
/**
 * Returns question from the API
 */
function useQa(
  filter: FetchQuestionsData,
  queryOptions?: Partial<UseQueryOptions<QA[], HttpError>>,
): UseQueryResult<QA[], HttpError> {
  return useQuery({
    queryKey: qaQueryKey(filter),
    queryFn: () => QaService.fetchQuestions(filter),
    ...queryOptions,
  });
}

export { qaQueryKey, useQa };
